import { Routes } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { PrivacyComponent } from './components/privacy/privacy.component';
import { TermsComponent } from './components/terms/terms.component';
import { DownloadsComponent } from './components/downloads/downloads.component';
import { ResellerComponent } from './components/reseller/reseller.component';
import { FaqComponent } from './components/faq/faq.component';
import { AboutComponent } from './components/about/about.component';
import { SupportComponent } from './components/support/support.component';

export const routes: Routes = [
    { path: '', component: HomeComponent },
    { path: 'home', component: HomeComponent },
    { path: 'privacy', component: PrivacyComponent },
    { path: 'terms', component: TermsComponent },
    { path: 'downloads', component: DownloadsComponent },
    { path: 'reseller', component: ResellerComponent },
    { path: 'faq', component: FaqComponent },
    { path: 'about', component: AboutComponent },
    { path: 'support', component: SupportComponent }
  ];
